import { useParams } from "react-router-dom";
import { clinicId } from "../../../constants";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { Button, CircularProgress } from "@mui/material";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { caseinjury } from "./services";
import usePrint from "../../../hooks/usePrint";
import { useContext } from "react";
import { EmrContext } from "../../index";
import usePopup from "@hooks/usePopup";
import useAuthentication from "@hooks/useAuthentication";

function CaseInjuryCertificate() {
  const { encounterId } = useParams();
  const { patientData } = useContext(EmrContext);
  const { user } = useAuthentication();
  const { showSnackbar } = usePopup();
  const { control, handleSubmit, reset } = useForm();
  const { printPdf, loading } = usePrint();
  const { mutate, isLoading } = useMutation(caseinjury, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success" && result.response) {
        printPdf(result.response);
        reset();
      }
    },
    onError: () => {
      showSnackbar({
        message: "Something went wrong",
        variant: "error",
        open: true,
        duration: 3000,
      });
    },
  });

  const onSubmit = (data: any) => {
    const body = {
      clinicId: clinicId,
      clinicianId: Number(user?.clinicianID),
      id: encounterId,
      description: data.description,
      mechanism: data.mechanism,
      severity: data.severity,
      site: data.site,
      deptId: Number(patientData?.encounter?.departmentId),
    };
    mutate(body);
  };

  const handleReset = () => {
    reset();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-3 gap-3">
      <CustomFormField
        control={control}
        element="input"
        fieldProps={{ label: "site" }}
        name="site"
        rules={{ required: "site required" }}
      />
      <CustomFormField
        control={control}
        element="input"
        fieldProps={{ label: "severity" }}
        name="severity"
        rules={{ required: "severity required" }}
      />
      <CustomFormField
        control={control}
        element="input"
        fieldProps={{ label: "mechanism" }}
        name="mechanism"
        rules={{ required: "mechanism required" }}
      />
      <CustomFormField
        control={control}
        element="input"
        fieldProps={{ label: "description" }}
        name="description"
        rules={{ required: "description required" }}
      />

      <div className="flex gap-x-2  items-center">
        <Button
          type="submit"
          color="success"
          disabled={isLoading || loading}
          endIcon={(isLoading || loading) && <CircularProgress size={20} />}
        >
          submit
        </Button>
        <Button color="error" onClick={handleReset}>
          reset
        </Button>
      </div>
    </form>
  );
}

export default CaseInjuryCertificate;
